module.exports = __webpack_public_path__ + "static/media/rule2.5cb1c0c6.png";